import React from 'react';
import { useNavigate } from 'react-router-dom';

import QRCodeModule from '../components/NewDashboard/components/QRCodeModule';
import { ROUTES } from '../utils/routes';

function QRCodeAssistantView() {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <div className="min-h-screen leading-relaxed text-gray-800">
      <div className="container mx-auto px-8 py-8">
        {/* Header Section */}
        <div className="mb-6 flex items-center justify-between">
          <h1 className="text-3xl font-bold text-rgpd-blue">
            Module Assistant Immobilier
          </h1>
          <button
            onClick={handleBackToDashboard}
            className="flex transform items-center gap-2 rounded-lg bg-white px-4 py-2 font-semibold text-rgpd-blue shadow-lg transition-all duration-300 hover:scale-105 hover:bg-gray-100 hover:shadow-xl"
          >
            <span>←</span>
            Retour au tableau de bord
          </button>
        </div>

        {/* QR Code Module Content */}
        <div className="rounded-xl bg-white p-8 shadow-xl">
          <QRCodeModule />
        </div>
      </div>
    </div>
  );
}

export default QRCodeAssistantView;

